import React from "react"
import styled from "styled-components"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import About from "../components/about"

const Wrapper = styled.div`
  padding-top: 50px;

  h1 {
    text-align: center;
    color: #fff;
  }

  ul {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    margin: 0 auto;
    padding: 0;
    div {
      cursor: pointer;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.laptop}) {
      max-width: 1024px;
    }
  }
`

const AboutPage = (props) => {
  const {_rawAboutMe, name, profile_picture } = props.data.about
  return (
    <Layout>
      <SEO title="About Me" />
      <Wrapper>
        <About
          title={name}
          details={_rawAboutMe}
          profile_picture={profile_picture}
        />
      </Wrapper>
    </Layout>
  )
}

export default AboutPage

export const aboutPageQuery = graphql`
  query AboutPage {
    about: sanityAbout {
    _rawAboutMe(resolveReferences: {maxDepth: 10})
    instagram
    facebook
    name
    introduction
    twitter
    id
      profile_picture {
        asset {
            fixed(width: 600, height: 200) {
              ...GatsbySanityImageFixed
            }
            fluid(maxWidth: 400) {
              ...GatsbySanityImageFluid
            }
          }
      }

    }
  }
`
